import React from 'react'
import { Translate } from "react-redux-i18n"; 
import UserDecorator from '../../containers/UserDecorator';
import PendingMemberRequest from '../../components/PendingMemberRequest';
import KreditzLogo from "../../styles/images/kreditz-logo.png";
import { Callout } from "@blueprintjs/core";
import TranslatedPage from "../../containers/TranslatedPage/TranslatedPage";

const PendingRequests=({member_requests, request_updates, takeAction, onMessageClick})=>{     
    return (            
        <div className="custom-card">
            <h1 className="bp3-heading">
                <Translate value="member_requests.pending_request" />
            </h1>
            <div className="identity-check-explainer">
                <Callout>
                    <div className="kreditz-logo">
                        <img src={KreditzLogo} alt="Kreditz Logo" />
                    </div>
                    <strong className="bp3-heading content-block"><TranslatedPage path="kreditz.title" /></strong>
                    <TranslatedPage path="kreditz.heading" />
                </Callout>
            </div>
            <div className="user-list requests">
                {
                    member_requests.map(request=>(
                        <UserDecorator userId={request.user_guid} key={request.user_guid} >
                            <PendingMemberRequest
                                requestId={request.guid}                   
                                takeAction={takeAction}
                                updating={request_updates[request.guid]}
                                onMessageClick={onMessageClick}                                                                  
                            />
                        </UserDecorator>
                    ))
                }            
            </div>
        </div>
    ) 
}
      
export default PendingRequests;